<template>
  <section class="content">
    <loading :active.sync="isLoading"
        :can-cancel="true"
        :is-full-page="fullPage"></loading>
    <div class="row center-block">
      <div class="col-md-12 row-rm-padding">
        <div class="box">
          <div class="box-body">
            <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
              <div class="row">
                <div class="col-sm-12">
                  <div id="example1_length" class="dataTables_length">
                    <div>
                      <h3><button class="btn primary-btn-my clear-new-modal" style="float: left;margin-bottom: 15px;margin-left: 15px;" @click="activateUsers">Activate</button></h3>
                      <button class="btn primary-btn-my" style="float: right;margin-bottom: 15px;margin-left: 15px;" @click.prevent="genarateUsersListPDF">{{usersList.buttonLabel}}</button>
                      <button class="btn primary-btn-my" style="float: right;margin-bottom: 15px;" @click.prevent="genarateMarktingAgreedUsersListPDF">{{usersMCAgreedList.buttonLabel}}</button>
                      <sync-loader style="float: right;" :loading="userListLoading" :color="'#FECD2F'" :size="'10px'" :width="'5px'" :margin="'2px'"></sync-loader>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 table-responsive">
                <table id="example" class="display table table-bordered table-striped dataTable">
                  <thead>
                      <tr>
                          <th style="width: 50px;">ID</th>
                          <th style="width: 50px;"><input type="checkbox" id="select-all" class="datatable-check-list"  value="all"></th>
                          <th style="width: 200px;">Date</th>
                          <th style="width: 200px;">Name</th>
                          <th style="width: 182px;">Email</th>
                          <th style="width: 142px;">Phone</th>
                          <th style="width: 101px;">Org-Name</th>
                          <th style="width: 101px;">Organization</th>
                          <th style="width: 101px;">Supervisor</th>
                          <th style="width: 101px;">Marketing Communications</th>
                          <th style="width: 101px;">Status</th>
                          <th style="width: 101px;">Actions</th>
                      </tr>
                  </thead>
                  <tbody></tbody>
              </table>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
     <!-- ================== User Active model ================== -->
     <md-dialog :md-active.sync="activeModal" class="model-show-new">
      <md-dialog-title class="model-title modal-width-100">Activate Users
        <a style="float: right;cursor: pointer;" class="md-primary" @click="activeModal = false">
          <md-icon class="close-btn" style="font-size: 18px !important;">close
          </md-icon>
        </a>
      </md-dialog-title>
      <div class="from-padding modal-width-100">
        <div v-if="this.errorActive" class="error-acction"><p>The Selected Users are already assigned to one or more Organisations. Please select users that have not been assigned to an Organisation OR only Users assigned to a single Organisation for each Bulk Activation.</p></div>
        <div class="left-select">
          <md-field>
            <label class="lable-fileds">Supervisor</label>
            <md-select v-model="activeUserData.superuser" name="superuser_id" id="superuser_id" :disabled="isDisabledSup">
              <md-option v-for="item in getSupervisorList" v-bind:key="item.id" :value="item.id" >
                {{item.name}}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <div class="right-select">
            <md-field>
            <label class="lable-fileds">Organization</label>
            <md-select v-model="activeUserData.organization" name="organization_id" class="organization_id" id="organization_id" @md-selected="loadSuperUsers(activeUserData.organization)" :disabled="isDisabledOrg">
              <md-option v-for="item in getOrganizationList" v-bind:key="item.id" :value="item.id" >
                {{item.name}}
              </md-option>
            </md-select>
          </md-field>
        </div>

        <div class="custom-modal-footer-spaces"></div>

        <div class="custom-modal-footer-container">
          <button type="button" class="btn primary-btn-my custom-modal-footer-items" @click="activateUsersAPI">
            Activate User
          </button>
          &nbsp;&nbsp;&nbsp;
          <sync-loader class="custom-modal-footer-items" :loading="newModalLoading" :color="newModalColor" :size="newModalSize" :width="newModalWidth" :margin="newModalMargin"></sync-loader>
        </div>

      </div>
    </md-dialog>

  </section>

</template>

<script>
  import $ from 'jquery'
  import api from '../../../api'
  import config from '../../../config'
  import Vue from 'vue'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  // Require needed datatables modules
  require('datatables.net')
  require('datatables.net-bs')
  var SyncLoader = require('vue-spinner/src/SyncLoader')
  var arr = []
  // var moment = require('moment')
  export default {
    name: 'UserView',
    components: {
      'SyncLoader': SyncLoader,
      Loading
    },
    data() {
      return {
        isLoading: false,
        fullPage: true,
        isDisabledOrg: false,
        isDisabledSup: false,
        errorActive: false,
        activeModal: false,
        active: false,
        dataTable: null,
        getOrganizationList: [],
        getSupervisorList: [],
        selectedUserList: [],
        usersList: {
          url: 'https://smartapprcp.s3.ap-southeast-1.amazonaws.com/rcp_docs/other/user/users.xlsx',
          buttonLabel: 'Download user list'
        },
        usersMCAgreedList: {
          url: 'https://smartapprcp.s3-ap-southeast-1.amazonaws.com/rcp_docs/other/user/userlist.xlsx',
          buttonLabel: 'Download emails accepted users'
        },
        activeUserData: {
          users: [],
          active: null,
          delete: null,
          superuser: null,
          organization: null
        },
        userListLoading: false,
        selectedSheet: null,
        sheetName: null,
        newModalColor: '#FECD2F',
        newModalSize: '10px',
        newModalLoading: false,
        newModalWidth: '5px',
        newModalMargin: '2px',
        collection: [{ a: 1, b: 2 }],
        sheets: [{ name: 'SheetOne', data: [{ c: 2 }] }]
      }
    },
    created() {
    },
    mounted() {
      this.$nextTick(() => {
        this.initDatable()
        this.initJqueryMethods()
        this.setCategoryDropDownData()
      })
      document.getElementById('select-all').onclick = function() {
        var checkboxes = document.querySelectorAll('input[type="checkbox"]')
        for (var checkbox of checkboxes) {
          checkbox.checked = this.checked
        }
      }
      $('#example').on('click', function () {
        $('#example input[type=checkbox]:checked').each(function () {
          if (this.value !== 'all') {
            arr.push(this.value)
          }
        })
        if (arr.length !== 10) {
          $('#select-all').prop('checked', false)
        } else {
          $('#select-all').prop('checked', true)
        }
        arr = []
      })
    },
    methods: {
      initDatable() {
        this.dataTable = $(document).ready(function() {
          $('#example').DataTable({
            'order': [[ 0, 'desc' ]],
            'deferRender': true,
            ajax: {
              url: config.serverURI + '/admin/users',
              type: 'get',
              contentType: 'application/json; charset=UTF-8',
              dataSrc: 'result.original.data',
              headers: { Authorization: 'Bearer ' + Vue.auth.getToken() }
            },
            'columns': [
              { 'data': 'id',
                'visible': false
              },
              { 'render': function (data, type, full, meta) {
                return '<input type="checkbox" class="datatable-check-list" value="' + full.id + '">'
              }
              },
              { 'data': 'updated_at' },
              { 'data': 'first_name',
                'render': function (data, type, full, meta) {
                  return '<span>' + full.first_name + ' ' + full.last_name + '</span>'
                }
              },
              { 'data': 'email' },
              { 'data': 'phone_no' },
              { 'data': 'org_name' },
              { 'render': function (data, type, full, meta) {
                if (full.organization_name !== null) {
                  return '<span>' + full.organization_name + '</span>'
                } else {
                  return '<span class="badge badge-warning">N/A</span>'
                }
              }
              },
              { 'render': function (data, type, full, meta) {
                if (!full.super_user_name) {
                  return '<span class="badge badge-warning">N/A</span>'
                }
                return '<span>' + full.super_user_name + '</span>'
              }
              },
              { 'render': function (data, type, full, meta) {
                if (full.marketing_agreement.toString() === '1') {
                  return '<span class="badge bg-green">Accepted</span>'
                } else if (full.marketing_agreement === 0 || full.marketing_agreement === false) {
                  return '<span class="badge bg-primary">Rejected</span>'
                }
                return '<span class="badge badge-warning">N/A</span>'
              }
              },
              { 'render': function (data, type, full, meta) {
                if (full.status === '1') {
                  return '<span class="badge bg-green">Active</span>'
                } else if (full.status === 0) {
                  return '<span class="badge bg-primary">Deactive</span>'
                }
                return '<span class="badge badge-warning">N/A</span>'
              }
              },
              { 'render': function (data, type, full, meta) {
                var returnString = ''
                if (full.status === '1') {
                  returnString += '<button type="button" data-id=' + full.id + ' data-status="true"  class="btn btn-info btn-sm  btn-change-status"><i class="fa fa-power-off" aria-hidden="true"></i></button>'
                } else if (full.status === 0) {
                  returnString += '<button type="button" data-id=' + full.id + ' data-status="false" class="btn btn-info btn-sm btn-change-status"><i class="fa fa-check" aria-hidden="true"></i></button>'
                }
                returnString += '&nbsp;<button type="button"  data-id=' + full.id + '  class="btn btn-danger btn-sm btn-delete"><i class="fa fa-trash-o" aria-hidden="true"></i></button>'
                return returnString
              }
              }
            ]
          })
          $('.dataTables_filter input').on('mouseup', function() {
            this.dataTable.draw()
          })
        })
      },
      clearNewForm() {
        this.activeUserData.users = []
        this.activeUserData.active = null
        this.activeUserData.delete = null
        this.activeUserData.superuser = null
        this.activeUserData.organization = null
        // this.selectedUserList = []
      },
      activateUsersAPI() {
        if (this.activeUserData.organization !== null) {
          this.activeUserData.active = 1
          this.newModalLoading = true
          api.request('post', '/bulkactions/userlist', this.activeUserData)
          .then(response => {
            if (response.status === 200) {
              this.newModalLoading = false
              this.activeModal = false
              this.clearNewForm()
              $('#example').DataTable().ajax.reload()
                // eslint-disable-next-line no-undef
              toast.fire({icon: 'success', title: 'Record updated successfully'})
            } else {
              this.newModalLoading = false
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
          })
        } else {
           // eslint-disable-next-line no-undef
          toast.fire({icon: 'error', title: 'Please select the data'})
        }
      },
      activateUsers() {
        var selected = []
        $('#example input[type=checkbox]:checked').each(function () {
          selected.push(this.value)
        })
        if (selected.length > 0) {
          this.isLoading = true
          this.getSelectedUserDetails(selected)
        } else {
          // eslint-disable-next-line no-undef
          toast.fire({icon: 'info', title: 'Please select at least one user'})
        }
      },
      getSelectedUserDetails(selectedList) {
        var checkList = []
        for (let x = 0; x < selectedList.length; x++) {
          if (selectedList[x] !== 'all') {
            checkList.push(selectedList[x])
          }
        }
        this.errorActive = false
        this.isDisabledOrg = false
        this.isDisabledSup = false
        var orID = null
        api.request('post', '/bulkactions/userlist/details', { users: checkList })
          .then(response => {
            this.selectedUserList = response.data.result
            this.activeUserData.users = checkList
            for (let x = 0; x < this.selectedUserList.length; x++) {
              if (orID === null) {
                if (this.selectedUserList[x].orID === null) {
                  orID = 0
                } else {
                  orID = this.selectedUserList[x].orID
                }
              } else {
                if (this.selectedUserList[x].orID !== null) {
                  if (this.selectedUserList[x].orID !== orID) {
                    this.errorActive = true
                  }
                }
              }
            }
            if (!this.errorActive) {
              if (orID === 0) {
                this.activeModal = true
              } else {
                this.activeUserData.organization = orID
                this.isDisabledOrg = true
                this.loadSuperUsers(orID)
                this.activeModal = true
              }
            } else {
              this.activeModal = true
              this.isDisabledOrg = true
              this.isDisabledSup = true
            }
            this.isLoading = false
          })
      },
      loadSuperUsers(id) {
        this.isDisabledSup = false
        this.activeUserData.superuser = null
        api
          .request('get', '/admin/organizations/special/' + id)
          .then(response => {
            this.getSupervisorList = response.data.result.user
            if (this.getSupervisorList.length === 0) {
              this.isDisabledSup = true
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'info', title: 'No data'})
            }
          })
      },
      setCategoryDropDownData() {
        api
          .request('get', '/admin/organizations/select')
          .then(response => {
            this.getOrganizationList = response.data.result
          })
      },
      initJqueryMethods() {
        var ref = this
        // edit modal open
        $('#example tbody').on('click', 'td button.btn-change-status', function () {
          var id = $(this).attr('data-id')
          var status = $(this).attr('data-status')
          ref.changeUserStatus(id, status)
        })
        // delete record
        $('#example tbody').on('click', 'td button.btn-delete', function () {
          var id = $(this).attr('data-id')
          ref.deleteUser(id)
        })
      },
      changeUserStatus(id, status) {
        var modalMessage = ''
        if (status !== 'true') {
          modalMessage = 'Allow User to login to RCP system again!'
        } else {
          modalMessage = 'User cant login to RCP system again!'
        }
        // eslint-disable-next-line next-line no-undef,no-undef
        Swal.fire({
          title: 'Are you sure?',
          text: modalMessage,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, change it!'
        }).then((result) => {
          if (result.value) {
            api.request('get', '/admin/users/changeStatus/' + id)
              .then(response => {
                if (response.status === 200 || response.status.status === 'success') {
                  // eslint-disable-next-line no-undef
                  toast.fire({icon: 'success', title: status === 'true' ? 'Account deactivated successfully' : 'Account actived  successfully'})
                  $('#example').DataTable().ajax.reload()
                  // this.dataTable.ajax.reload()
                }
              }).catch(error => {
              // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: error})
              })
          }
        })
      },
      deleteUser(id) {
        // eslint-disable-next-line no-undef
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            api.request('get', '/admin/users/delete/' + id)
              .then(response => {
                if (response.status === 200 || response.status.status === 'success') {
                  // eslint-disable-next-line no-undef
                  toast.fire({icon: 'success', title: 'Record successfully deleted'})
                  $('#example').DataTable().ajax.reload()
                }
              }).catch(error => {
              // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: error})
              })
          }
        })
      },
      genarateUsersListPDF() {
        this.userListLoading = true
        var ref = this
        api.request('get', '/users/export')
        .then(response => {
          if (response.data.result === true) {
            ref.downloadUsers()
          } else {
            alert('error while downloading')
          }
        }).catch(error => {
          this.userListLoading = false
          alert(error)
        })
      },
      downloadUsers() {
        var ref = this
        api.httpRequestCore({
          method: 'get',
          url: this.usersList.url,
          responseType: 'arraybuffer'
        })
          .then(response => {
            ref.forceFileDownload(response)
          })
          .catch(error => {
            ref.userListLoading = false
            alert(error)
          })
      },
      forceFileDownload(response) {
        this.userListLoading = false
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'users_list.xlsx') // or any other extension
        document.body.appendChild(link)
        link.click()
      },
      genarateMarktingAgreedUsersListPDF() {
        this.userListLoading = true
        var ref = this
        api.request('get', '/users/marketingAgreement')
        .then(response => {
          if (response.data.result === true) {
            ref.downloadMarktingAgreedUsers()
          } else {
            alert('error while downloading')
          }
        }).catch(error => {
          this.userListLoading = false
          alert(error)
        })
      },
      downloadMarktingAgreedUsers() {
        var ref = this
        api.httpRequestCore({
          method: 'get',
          url: this.usersMCAgreedList.url,
          responseType: 'arraybuffer'
        })
          .then(response => {
            ref.forceFileMarktingAgreedDownload(response)
          })
          .catch(error => {
            ref.userListLoading = false
            alert(error)
          })
      },
      forceFileMarktingAgreedDownload(response) {
        this.userListLoading = false
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'Markting_communications_agreed_users.xlsx') // or any other extension
        document.body.appendChild(link)
        link.click()
      }
    }
  }

</script>

<style>
  @import url('/static/js/plugins/datatables/dataTables.bootstrap.css');

  table.dataTable thead .sorting:after,
  table.dataTable thead .sorting_asc:after,
  table.dataTable thead .sorting_desc:after {
    font-family: 'FontAwesome';
  }

  table.dataTable thead .sorting:after {
    content: '\f0dc';
  }

  table.dataTable thead .sorting_asc:after {
    content: '\f0dd';
  }

  table.dataTable thead .sorting_desc:after {
    content: '\f0de';
  }


</style>



// WEBPACK FOOTER //
// UserView.vue?58720a3a